import React from "react";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import { useTranslation } from "react-i18next";
import HourCollectionsTable from "./HourCollectionsTable";

export default function HourCollectionsList() {
  const { t } = useTranslation();

  return (
    <div className="page-content">
      <div className="container-fluid">
        <Breadcrumbs title="" breadcrumbItem={t("Hours Collections")} />
        <HourCollectionsTable />
      </div>
    </div>
  );
}
